import { jsx as _jsx } from "react/jsx-runtime";
import { CircleSolidIcon } from '@bnb-chain/icons';
import { forwardRef, Icon, theme } from '@chakra-ui/react';
export const TagLeftBullet = forwardRef((props, ref) => {
    return (_jsx(Icon, { ref: ref, as: CircleSolidIcon, fontSize: theme.sizes['1.5'], verticalAlign: "top", mr: theme.sizes['2'], ...props }));
});
